import { render, staticRenderFns } from "./SfHeading.vue?vue&type=template&id=a003345a&"
import script from "./SfHeading.vue?vue&type=script&lang=js&"
export * from "./SfHeading.vue?vue&type=script&lang=js&"
import style0 from "./SfHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports